import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faRedoAlt, faLongArrowAltUp, faLongArrowAltDown } from '@fortawesome/free-solid-svg-icons';
import { Button, Input } from "reactstrap";
import { documentFilterItems } from "../../../../utils/constants"
import "./index.scss";
import FilterFile from "./FilterFile";
import AutoPopulateList from "../../../../components/common/AutoPopulateList";
import { useDispatch } from "react-redux";
const DocSearchBlock = ({ _handleSearch, _filterDocs, __filterDocs, _resetFilter, _handleElasticSearch, elasticSearchList, focusSearchFlag, __focusSearch, filter, sortBySelected, __sortBySelected, filterSelected, __filterSelected, myAssignedSelected, __myAssignedSelected }) => {

	//	const [filterSelected, setFilterSelected] = useState();
	//const [sortBySelected, setSortBySelected] = useState();
	const [keyword, setKeyword] = useState(filter);
	const dispatch = useDispatch();
	const [focusSearch, setFocusSearch] = useState(false);
	const selectedFilter = documentFilterItems[filterSelected];


	/***
	 * @description function use for search trigger
	 * @param {refObj} event accepting element event 
	 */
	const onKeyDownEvent = (event) => {
		if (event.key === 'Enter') {
			if (elasticSearchList.length) {
				if (event.target.value.trim() && event.target.value.trim().replace(/\./g, "")) {
					setKeyword(event.target.value)
					setFocusSearch(false)
					_handleSearch(event.target.value, null);
				} else {
					setKeyword(event.target.value.trim().replace(/\./g, ""))
					setFocusSearch(false)
					_handleSearch(null, null);
				}
			}
		}
	}

	const __handleElasticSearch = (val) => {
		if (val.trim() && val.trim().replace(/\./g, "")) {
			setFocusSearch(true)
			setKeyword(val)
			_handleElasticSearch(val.trim());
		} else {
			setFocusSearch(false)
			setKeyword(val.trim().replace(/\./g, ""));
			_handleSearch(null, null)
		}
	};

	const handleSelectedAction = (val, moreInfoObj) => {
		moreInfoObj.keyword = keyword
		//setKeyword(val)
		setFocusSearch(false)
		_handleSearch(val, moreInfoObj);

	}
	/***
	 * @description function use for handle elastic search view more
	 */
	const viewMore = () => {
		setFocusSearch(false)
		_handleSearch(keyword, null);
	}
	/***
	 * @description function use for handle restElasticSearch
	 */
	const restElasticSearch = () => {
		setKeyword('')
		setFocusSearch(false)
		_handleSearch(null, null);

	}

	const resetDocs = (v) => {

		dispatch({ type: "UPDATE_FOLDER_LABEL", data: null });
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: '' });
		// _resetFilter(v)
		setKeyword('')
		__filterSelected(null);
		__sortBySelected('2');
		__filterDocs('updatedAt', '-1', 2, false, true);
		// _filterDocs(null, false)
		// setFilterSelected(null);
		//setSortBySelected(null);
	}

	const onClick = (v) => {
		__focusSearch(true);
		if (keyword) {
			_handleElasticSearch(keyword.trim());
			setFocusSearch(true)
		}
	};

	// marginRight: "4px"   => style of vr or cr

	return (<>
		<div className="docs-search-blc position-relative d-flex align-items-center position-relative">
			{/*<div className='toggle-btn-sidebar d-inline-flex align-items-center justify-content-center'>
				<Button color="link" className="d-inline-flex align-items-center justify-content-center">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						fill="none"
						viewBox="0 0 24 24"
					>
						<path
							fill="#626163"
							d="M12.008 23.97H4.439a4.346 4.346 0 01-4.15-2.874 4.783 4.783 0 01-.288-1.544V4.434A4.362 4.362 0 012.73.32 4.377 4.377 0 014.438 0h15.122a4.384 4.384 0 014.117 2.728c.22.541.33 1.121.322 1.706v15.132a4.368 4.368 0 01-2.731 4.112c-.542.22-1.123.33-1.708.322-2.545-.023-5.038-.03-7.553-.03zm0-16.832h6.924a1.08 1.08 0 001.006-1.551 1.109 1.109 0 00-1.102-.629H5.179a2.32 2.32 0 00-.325 0 1.044 1.044 0 00-.822.74A1.078 1.078 0 005.12 7.13l6.888.007zm0 9.702H5.09a1.089 1.089 0 00-1.05 1.477 1.13 1.13 0 001.169.74h13.59a1.179 1.179 0 00.925-.34 1.085 1.085 0 00-.814-1.84l-6.902-.037zm0-5.911H4.994a1.082 1.082 0 00-1.033.972c-.017.172.007.345.071.505a1.123 1.123 0 001.162.74h13.834a1.087 1.087 0 00.604-1.898 1.088 1.088 0 00-.774-.268l-6.85-.051z"
						></path>
					</svg>
				</Button>
			</div> */}
			<div className="input-col position-relative">
				<Input type="text" value={keyword} placeholder="Search" onChange={(e) => { if (e.target.value !== " ") { __handleElasticSearch(e.target.value) } }} onClick={(e) => { onClick(e.target.value) }}
					onKeyDown={(e) => {
						if (e.key === '.') {
							e.stopPropagation();
							e.preventDefault();
						} else {
							onKeyDownEvent(e)
						}
					}} />
				<FilterFile
					className="filter-blc filter-blc2 position-absolute"
					_filterSelected={filterSelected}
					_sortBySelected={sortBySelected}
					_myAssignedSelected={myAssignedSelected}
					_filter={(v) => { _filterDocs(v); __filterSelected(Number(v)) /*setFilterSelected(Number(v)) */ }} __filter={(sortBy, order, v) => { __filterDocs(sortBy, order, v); __sortBySelected(v) /*setSortBySelected(v)*/ }}
					_myAssignedSelectedFilter={(val) => {__myAssignedSelected(val)}}
				/>
				<span className="inputIcon position-absolute d-inline-flex align-items-center justify-content-center">
					<FontAwesomeIcon icon={faSearch} />
				</span>

				<Button data-toggle="tooltip" data-placement="top" title={'Reset'} color="link" onClick={resetDocs} className="reset-btn position-absolute">
					<FontAwesomeIcon icon={faRedoAlt} />
				</Button>
				{/*focusSearch && elasticSearchList?.length > 0 && ( 
				 <AutoPopulateList  searchList={elasticSearchList} _handleSelectedAction={(val) => handleSelectedAction(val)} _handleFilePageChange={viewMore} />
				)*/}
				{focusSearch && focusSearchFlag && (
					<AutoPopulateList searchList={elasticSearchList} _handleSelectedAction={(val, moreInfoObj) => handleSelectedAction(val, moreInfoObj)} _handleFilePageChange={viewMore} _resetSearch={restElasticSearch} type='folder' />
				)}
			</div>
		</div>
		<div className="file-filter-block docs-search-blc">
			<div className="row-block d-flex align-items-center justify-content-between">
				<div className="lbl">Showing:- {!selectedFilter?.label ? "All records" : ''}</div>
				<div className="right-col d-flex align-items-center ms-auto">
					{selectedFilter?.label ? <ul className="status-items">
						<li className="d-flex align-items-center">
							{selectedFilter.label == "Archived" ? (
								<span className={`d-inline-flex align-items-center justify-content-center`}>Archived</span>
							) : (
								<div>
									<span className={`d-inline-flex align-items-center justify-content-center item ${selectedFilter?.is_verified == 1 ? "green-round" : selectedFilter?.is_verified == 2 ? "red-square" : null}`}>V</span>
									{selectedFilter?.label == "CR OR VR" ? (
										<span className={'d-inline-flex align-items-center justify-content-center or-txt'} style={{ marginRight: "4px" }}>OR</span>
									) : (
										<span className={'d-inline-flex align-items-center justify-content-center'}></span>
									)}
									<span className={`d-inline-flex align-items-center justify-content-center item ${selectedFilter?.is_correct == 1 ? "green-round" : selectedFilter?.is_correct == 2 ? "red-square" : null}`}>C</span>
								</div>
							)}
						</li>
					</ul> : null}
					{sortBySelected ? <ul className="sort-status-item">
						{sortBySelected == '1' ?
							<li className="d-inline-flex align-items-center">
								<span className="icon">
									<img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-down.svg')} alt="arrow" />
									{/* <img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-up.svg')} alt="arrow" /> */}
								</span>
								<span className="txt">
									Date <span>-</span>Asc
								</span>
							</li>
							: sortBySelected == '2'
								? <li className="d-inline-flex align-items-center">
									<span className="icon">
										{/* <img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-down.svg')} alt="arrow" /> */}
										<img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-up.svg')} alt="arrow" />
									</span>
									<span className="txt">
										Date <span>-</span>Desc
									</span>
								</li>
								: sortBySelected == '3' ?
									<li className="d-inline-flex align-items-center">
										<span className="icon">
											<img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-down.svg')} alt="arrow" />
											{/* <img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-up.svg')} alt="arrow" /> */}
										</span>
										<span className="txt">
											Loan No <span>-</span>Asc
										</span>
									</li>
									: sortBySelected == '4' ?
										<li className="d-inline-flex align-items-center">
											<span className="icon">
												{/* <img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-down.svg')} alt="arrow" /> */}
												<img className="img-fluid" src={require('../../../../assets/img/icons/sort-arrow-up.svg')} alt="arrow" />
											</span>
											<span className="txt">
												Loan No <span>-</span>Desc
											</span>
										</li> :
										null

						}
						{/* <li className="d-inline-flex align-items-center">
							<span className="icon">
								<FontAwesomeIcon icon={faLongArrowAltDown} />
							</span>
							<span className="txt">
								Date <span>-</span>Desc
							</span>
						</li> */}
					</ul> : null}
				</div>
			</div>
		</div>
	</>
	)
};
export default DocSearchBlock;